@let dateRange = this.date();

@if (this.isReady()) {
  <div class="flex-start g-space-md">
    <div class="grid-control-container c-pointer">
      <div class="trigger" (click)="this.changeMode('day')" [class.active]="this.mode() === 'day'">
        {{ 'calendar.common.day' | translate }}
      </div>
      <div class="sep"></div>
      <div class="trigger" (click)="this.changeMode('week')" [class.active]="this.mode() === 'week'">
        {{ 'calendar.common.week' | translate }}
      </div>
      <div class="sep"></div>
      <div class="trigger" (click)="this.changeMode('month')" [class.active]="this.mode() === 'month'">
        {{ 'calendar.common.month' | translate }}
      </div>
    </div>
    @if (dateRange) {
      <div class="flex-start g-space-xs align-center">
        <cam-button-tool (action)="this.goToPrevious()" icon="arrow-big-left"></cam-button-tool>
        <cam-button-tool> {{ dateRange.start | date }} - {{ dateRange.end | date }} </cam-button-tool>
        <cam-button-tool (action)="this.goToNext()" icon="arrow-big-right"></cam-button-tool>
      </div>
    }
    <div class="flex-start g-space-xs align-center">
      <cam-button-tool (action)="this.goToToday()">{{ 'calendar.common.today' | translate }}</cam-button-tool>
    </div>

    <div class="flex-start g-space-xs align-center">
      <cam-button-tool
        (action)="this.toggleMap()"
        [state]="this.mapOpened() ? 'selected' : 'classic'"
        icon="star-shield"
      ></cam-button-tool>
    </div>
  </div>
}
